import { Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { theme } from '../utils/theme';
import RootineButton from './RootineButton';

export interface ImageHeroProps {
  image: string;
  alttext: string;
  title: string;
  description?: string;
  height?: number;
  smallImage?: boolean;
  cta?: string;
  link?: string;
}

export const ImageHero = (props: ImageHeroProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      {isMobile ? (
        <>
          <Grid
            container
            flexDirection="column"
            height="100%"
            alignItems={props.cta ? 'center' : 'flex-start'}
            sx={{ py: { xs: 2 } }}
          >
            <Stack>
              <Grid item xs={12}>
                <Typography color="black" variant="medium" fontSize={24}>
                  {props.title}
                </Typography>
              </Grid>
              {props.description && (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography
                    variant="light"
                    color="text.secondary"
                    fontSize={14}
                  >
                    {props.description}
                  </Typography>
                </Grid>
              )}
            </Stack>
          </Grid>
          <div
            style={{
              position: 'relative',
              backgroundColor: 'black',
              height: props.height || 450,
              zIndex: 1,
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundImage: `url(${props.image})`,
                backgroundSize: props.smallImage ? 'contain' : 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                opacity: 1,
                zIndex: -1,
              }}
            ></div>
          </div>
        </>
      ) : (
        <div
          style={{
            position: 'relative',
            backgroundColor: 'black',
            height: props.height || 450,
            zIndex: 1,
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundImage: `url(${props.image})`,
              backgroundSize: props.smallImage ? 'contain' : 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              opacity: 1,
              zIndex: -1,
            }}
          ></div>
          <Grid
            container
            item
            xs={12}
            height="100%"
            alignItems={props.cta ? 'center' : 'flex-start'}
            sx={{ pl: { xs: 2, md: 4 }, pt: { xs: 2, md: 4 }, width: 425 }}
          >
            <Stack sx={{ width: '100%' }}>
              <Grid item xs={8} sm={12}>
                <Typography color="black" variant="medium" fontSize={40}>
                  {props.title}
                </Typography>
              </Grid>
              {props.description && (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Typography color="black">{props.description}</Typography>
                </Grid>
              )}
              {props.cta && props.link && (
                <Grid item xs={12} sx={{ pt: { xs: 2, md: 8 } }}>
                  <RootineButton
                    size="medium"
                    hideIcon
                    sx={{ width: '50%' }}
                    variation="primary"
                    href={props.link}
                    label={props.cta || 'button label'}
                  />
                </Grid>
              )}
            </Stack>
          </Grid>
        </div>
      )}
    </>
  );
};
